export enum OrganizationApiKeyType {
  Default = 0,
  BillingSync = 1,
  Scim = 2,
}
